import React, { memo } from 'react';

import {
  Button,
  Typography,
} from 'antd';

import assets from '../../../../assets';
import { dynamicItemTitle } from '../../../../shared/utils';
import NoDataFound from '../../../Feed/components/NoDataFound/NoDataFound';
import TQConnectScoreCard
  from '../../components/TQConnectScoreCard/TQConnectScoreCard';
import { useSubmitTQProfileContext } from './SubmitTQProfileContextProvider';

interface Props {
  openUserProfile: () => void;
  openRequestsDiscovery: () => void;
}

const ProfileCompletion: React.FC<Props> = ({
  openUserProfile,
  openRequestsDiscovery,
}) => {
  const {
    tqProfileCompletionState: { assignedTQScore },
  } = useSubmitTQProfileContext();

  return (
    <div className="profile-completion__card">
      <div
        className="card__confetti"
        style={{
          backgroundImage: `url(${assets.svg.fullMarksCelebration})`,
        }}
      />

      <TQConnectScoreCard
        score={assignedTQScore}
        showInfoIcon={false}
        isOwnScore
      />

      <NoDataFound
        showIcon={false}
        title={
          <Typography.Title level={3}>🎉 Profile completed!</Typography.Title>
        }
        subtitle={
          <>
            You’ve earned +{assignedTQScore}{' '}
            {dynamicItemTitle('tq-score', 'upper')} points 🎯 for completing
            your profile.
          </>
        }
        subtitle2={`🚀 You’re now ready to create or request ${dynamicItemTitle('tq-offerings', 'lower')}, and unlock meaningful opportunities within the community.`}
        extra={
          <>
            <Button
              className="siteBtn darkBtn"
              style={{ minWidth: 300, marginTop: 32, marginBottom: 12 }}
              onClick={openUserProfile}>
              Go to my profile
            </Button>
            <Button
              className="siteBtn grayBtn outlineBtn"
              style={{ minWidth: 300 }}
              onClick={openRequestsDiscovery}>
              Start exploring{' '}
              {dynamicItemTitle('tq-offering-requests', 'lower')}
            </Button>
          </>
        }
      />
    </div>
  );
};

export default memo(ProfileCompletion);
